$('.faq').click(function (e) {
    $(this).toggleClass('__open');
});